import React from "react";
import "../../App.css";

export default function COP() {
  return (
    <div className="cop-container">
      <h1 className="cop">Code of Practice</h1>
      <div className="cop-info">
        <p>The Philippine Language School of Victoria Incorporated acknowledges that it operates within the regulations and is accountable
          to the Department of Education and Training Victoria and it's local community
        </p>
        <h2>Principles</h2>
        <ul>
              <li>&#8226; The learning needs and welfare of the students are the primary considerations in decision making</li>
              <li>&#8226; Loyalty to the school, its administration and staff will be paramount in all decision making</li>
              <li>&#8226; The views of the school community will be canvassed and considered in policy issues where appropriate</li>
              <li>&#8226; Committee discussions and decisions on some matters will remain strictly confidential</li>
              <li>&#8226; Meetings and decision making procedures will operate in accordance with the school management standing orders. These can be revised as required</li>
              <li>&#8226; Faculty members will receive ongoing professional development training to assist them with their role and responsibilities</li>
              <li>&#8226; Implement what has been disseminated by the Victoria Curriculum and Assessment Authority (VCAA) in matter of the community of the community language</li>
        </ul>
        <h2>Principal</h2>
        <ul>
              <li>&#8226; Ensure the school's educational program incorporates current best practice and that is recognizes the learning needs of all students</li>
              <li>&#8226; Implement the school policy on assessment and reporting of student progress, that provides useful information to parents and students</li>
              <li>&#8226; Be responsible on the regular monitoring and reporting performances to ensure the essential of a quality education for all students</li>
              <li>&#8226; Manage the school's financial resources within the budget and in an accountable manner</li>
              <li>&#8226; Ensures that the contract of the rented facilities are followed for the achievement of goals and priorities</li>
              <li>&#8226; Ensure that staff selection complies with the policies and principles of merit and  equality</li>
              <li>&#8226; Encourage a cooperative school-parent relationship through different school programs and activities</li>
              <li>&#8226; Managing ongoing support services and updated resources for students, teachers and parents</li>
        </ul>
        <h2>Staff</h2>
        <ul>
              <li>&#8226; Implement current curriculum initiatives and program in line with the Victorian Curriculum</li>
              <li>&#8226; Showing genuine concern for all students in their care, promoting their self-image and confidence as successful learners
                through respecting and providing their individual differences
              </li>
              <li>&#8226; Be prepared and punctual for all classes, work duties and responsibilities</li>
              <li>&#8226; Create and maintain attractive and positive learning environment</li>
              <li>&#8226; Provide accurate, constructive feedback to parents using agreed assessment and reporting</li>
              <li>&#8226; Provide recognition of students' performance</li>
              <li>&#8226; Demonstrate a commitment to the school curriculum and policies through teamwork</li>
              <li>&#8226; Provide positive role models for students through behavious, dress and work practices</li>
              <li>&#8226; Encourage and develop students' active participation, resilience, creativity in learning, a sense of self-esteem and confidence</li>
              <li>&#8226; Participate in goal setting and self-evaluation while maintaining confidentiality</li>
        </ul>
        <h2>Community</h2>
        <ul>
              <li>&#8226; Support the school by participating in all school activities</li>
              <li>&#8226; Actively support the school by improving school resources</li>
              <li>&#8226; Respect and acknowledge community members' rights and confidentiality</li>
              <li>&#8226; Actively support students' welfare, discipline policy and program of the school</li>
              <li>&#8226; Promote the school amongst the wider community</li>
              <li>&#8226; Demonstrate loyalty to the school by adhering to the school policies and programs</li>
              <li>&#8226; Communicate readily and openly with the principal and staff</li>
        </ul>
      </div>
    </div>
  );
}
